// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Hr9qfP {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--surface-neutral-white);
  max-height: calc(100vh - 155px);
  overflow: hidden;
}

.DKz19_ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-1-5);
  padding: var(--spacing-3) var(--spacing-3) var(--spacing-2);
  border-bottom: 1px solid var(--stepper-card-header-border);
}

.PCIJWS {
  display: flex;
  align-items: center;
  gap: var(--spacing-1-5);
}

._G6Mtf {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.OdtmyC {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--spacing-3);
  height: var(--spacing-3);
  border-radius: 50%;
  font-family: var(--font-family-base);
  font-size: var(--type-label-md-font-size);
  font-weight: var(--type-label-md-font-weight);
  line-height: 1;
}

.OdtmyC.HG2_NE {
  background-color: var(--surface-primary-medium);
  color: var(--on-surface-neutral-white);
}

.OdtmyC.TSIYUM {
  background-color: var(--surface-support-success);
  color: var(--on-surface-neutral-white);
}

.OdtmyC.rp0Vmz {
  background-color: transparent;
  color: var(--text-neutral-strong);
  border: 1px solid var(--border-neutral-strong);
}

.VSFMac {
  font-size: var(--type-label-md-font-size);
  font-weight: var(--type-label-md-font-weight);
}

.HR2WOI {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--type-title-md-font-size);
  font-weight: var(--type-paragraph-lg-regular-font-weight);
  line-height: var(--type-label-lg-regular-line-height);
  color: var(--text-neutral-dark);
}

.m5Dum_ {
  height: 1px;
  background-color: var(--stepper-card-header-border);
  margin-top: var(--spacing-2);
}

.NgeAhx {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: var(--spacing-3);
  overflow-y: auto;
  min-height: 0;
}

.pnIweR {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  align-self: stretch;
  gap: var(--spacing-1-5);
  padding: var(--spacing-3);
  background-color: var(--surface-neutral-white);
  flex-shrink: 0;
}

.ORcEa8 {
  justify-content: space-between;
}

.Ks72yv {
  flex: 1;
  min-width: 0;
}

.SPXghZ {
  display: flex;
  align-items: center;
  margin-right: auto;
}

.CjJ8uM {
  font-size: var(--type-label-md-font-size);
  font-weight: 400;
  color: var(--text-neutral-dark);
  white-space: nowrap;
}

.cKUYmq {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: var(--spacing-1-5);
  flex-shrink: 0;
}

.fTULfn {
  width: auto !important;
  min-width: 100px !important;
  max-width: none !important;
  flex-shrink: 0 !important;
  padding: var(--spacing-1) var(--spacing-2) !important;
  font-size: var(--type-label-md-font-size) !important;
  font-weight: var(--type-label-md-font-weight) !important;
  border-radius: var(--radius-s) !important;
  box-shadow: none !important;
  line-height: var(--type-label-md-line-height) !important;
  text-align: center !important;
  white-space: nowrap !important;
}

.fTULfn[data-variant='secondary'] {
  background-color: var(--surface-neutral-white) !important;
  border: 2px solid var(--surface-primary-medium) !important;
  color: var(--surface-primary-medium) !important;
}

.fTULfn[data-variant='secondary']:hover:not(:disabled) {
  background-color: var(--surface-neutral-softer) !important;
}

.fTULfn[data-variant='primary'] {
  background-color: var(--surface-primary-medium) !important;
  border: 2px solid var(--surface-primary-medium) !important;
  color: var(--on-surface-neutral-white) !important;
}

.fTULfn[data-variant='primary']:hover:not(:disabled) {
  background-color: var(--surface-primary-strong) !important;
  border: 2px solid var(--surface-primary-strong) !important;
}

.fTULfn:disabled {
  opacity: var(--opacity-0-5) !important;
  cursor: not-allowed !important;
}

.AJ_A70[data-variant='primary']:disabled {
  background-color: var(--surface-neutral-soft) !important;
  border-color: var(--surface-neutral-soft) !important;
  color: var(--text-neutral-strong) !important;
  opacity: 1 !important;
}

@media (max-width: 768px) {
  .Hr9qfP {
    max-height: calc(100vh - 100px);
  }

  .DKz19_ {
    padding: var(--spacing-2) var(--spacing-2) var(--spacing-1-5);
    flex-shrink: 0;
  }

  .NgeAhx {
    padding: var(--spacing-2);
    overflow-y: auto;
    min-height: 0;
  }

  .pnIweR {
    padding: var(--spacing-2);
    justify-content: flex-end;
    gap: var(--spacing-1);
    flex-shrink: 0;
    border-top: 1px solid var(--border-neutral-medium);
  }

  .ORcEa8 {
    justify-content: space-between;
    padding: var(--spacing-3);
  }

  .CjJ8uM {
    font-size: var(--type-label-sm-font-size);
  }

  .cKUYmq {
    gap: var(--spacing-1);
  }

  .fTULfn {
    width: auto !important;
    min-width: 100px !important;
    max-width: none !important;
  }
}

@media (max-width: 600px) {
  .ORcEa8 {
    align-items: stretch;
    flex-direction: column;
    gap: var(--spacing-1-5);
    padding: var(--spacing-2);
  }

  .Ks72yv {
    width: 100%;
  }

  .ORcEa8 .cKUYmq {
    align-self: flex-end;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-layout/src/components/StepperCard/StepperCard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,wCAAwC;EACxC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,2DAA2D;EAC3D,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,oCAAoC;EACpC,yCAAyC;EACzC,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,+CAA+C;EAC/C,sCAAsC;AACxC;;AAEA;EACE,gDAAgD;EAChD,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,8CAA8C;AAChD;;AAEA;EACE,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,yCAAyC;EACzC,yDAAyD;EACzD,qDAAqD;EACrD,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,mDAAmD;EACnD,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,qDAAqD;EACrD,oDAAoD;EACpD,wDAAwD;EACxD,yCAAyC;EACzC,2BAA2B;EAC3B,wDAAwD;EACxD,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,yDAAyD;EACzD,0DAA0D;EAC1D,+CAA+C;AACjD;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,0DAA0D;EAC1D,0DAA0D;EAC1D,iDAAiD;AACnD;;AAEA;EACE,0DAA0D;EAC1D,0DAA0D;AAC5D;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,wDAAwD;EACxD,oDAAoD;EACpD,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,6DAA6D;IAC7D,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,kDAAkD;EACpD;;EAEA;IACE,8BAA8B;IAC9B,yBAAyB;EAC3B;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;EAC3B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".stepperCard {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: var(--surface-neutral-white);\n  max-height: calc(100vh - 155px);\n  overflow: hidden;\n}\n\n.stepperHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--spacing-1-5);\n  padding: var(--spacing-3) var(--spacing-3) var(--spacing-2);\n  border-bottom: 1px solid var(--stepper-card-header-border);\n}\n\n.stepIndicator {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1-5);\n}\n\n.headerActions {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.stepCircle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--spacing-3);\n  height: var(--spacing-3);\n  border-radius: 50%;\n  font-family: var(--font-family-base);\n  font-size: var(--type-label-md-font-size);\n  font-weight: var(--type-label-md-font-weight);\n  line-height: 1;\n}\n\n.stepCircle.active {\n  background-color: var(--surface-primary-medium);\n  color: var(--on-surface-neutral-white);\n}\n\n.stepCircle.completed {\n  background-color: var(--surface-support-success);\n  color: var(--on-surface-neutral-white);\n}\n\n.stepCircle.inactive {\n  background-color: transparent;\n  color: var(--text-neutral-strong);\n  border: 1px solid var(--border-neutral-strong);\n}\n\n.stepNumber {\n  font-size: var(--type-label-md-font-size);\n  font-weight: var(--type-label-md-font-weight);\n}\n\n.stepTitle {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--type-title-md-font-size);\n  font-weight: var(--type-paragraph-lg-regular-font-weight);\n  line-height: var(--type-label-lg-regular-line-height);\n  color: var(--text-neutral-dark);\n}\n\n.stepDivider {\n  height: 1px;\n  background-color: var(--stepper-card-header-border);\n  margin-top: var(--spacing-2);\n}\n\n.stepperContent {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  padding: var(--spacing-3);\n  overflow-y: auto;\n  min-height: 0;\n}\n\n.stepperActions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  align-self: stretch;\n  gap: var(--spacing-1-5);\n  padding: var(--spacing-3);\n  background-color: var(--surface-neutral-white);\n  flex-shrink: 0;\n}\n\n.stepperActionsWithFooterContent {\n  justify-content: space-between;\n}\n\n.footerContent {\n  flex: 1;\n  min-width: 0;\n}\n\n.totalValueDisplay {\n  display: flex;\n  align-items: center;\n  margin-right: auto;\n}\n\n.totalLabel {\n  font-size: var(--type-label-md-font-size);\n  font-weight: 400;\n  color: var(--text-neutral-dark);\n  white-space: nowrap;\n}\n\n.actionsButtons {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: var(--spacing-1-5);\n  flex-shrink: 0;\n}\n\n.stepperButton {\n  width: auto !important;\n  min-width: 100px !important;\n  max-width: none !important;\n  flex-shrink: 0 !important;\n  padding: var(--spacing-1) var(--spacing-2) !important;\n  font-size: var(--type-label-md-font-size) !important;\n  font-weight: var(--type-label-md-font-weight) !important;\n  border-radius: var(--radius-s) !important;\n  box-shadow: none !important;\n  line-height: var(--type-label-md-line-height) !important;\n  text-align: center !important;\n  white-space: nowrap !important;\n}\n\n.stepperButton[data-variant='secondary'] {\n  background-color: var(--surface-neutral-white) !important;\n  border: 2px solid var(--surface-primary-medium) !important;\n  color: var(--surface-primary-medium) !important;\n}\n\n.stepperButton[data-variant='secondary']:hover:not(:disabled) {\n  background-color: var(--surface-neutral-softer) !important;\n}\n\n.stepperButton[data-variant='primary'] {\n  background-color: var(--surface-primary-medium) !important;\n  border: 2px solid var(--surface-primary-medium) !important;\n  color: var(--on-surface-neutral-white) !important;\n}\n\n.stepperButton[data-variant='primary']:hover:not(:disabled) {\n  background-color: var(--surface-primary-strong) !important;\n  border: 2px solid var(--surface-primary-strong) !important;\n}\n\n.stepperButton:disabled {\n  opacity: var(--opacity-0-5) !important;\n  cursor: not-allowed !important;\n}\n\n.stepperButtonDisabledNeutral[data-variant='primary']:disabled {\n  background-color: var(--surface-neutral-soft) !important;\n  border-color: var(--surface-neutral-soft) !important;\n  color: var(--text-neutral-strong) !important;\n  opacity: 1 !important;\n}\n\n@media (max-width: 768px) {\n  .stepperCard {\n    max-height: calc(100vh - 100px);\n  }\n\n  .stepperHeader {\n    padding: var(--spacing-2) var(--spacing-2) var(--spacing-1-5);\n    flex-shrink: 0;\n  }\n\n  .stepperContent {\n    padding: var(--spacing-2);\n    overflow-y: auto;\n    min-height: 0;\n  }\n\n  .stepperActions {\n    padding: var(--spacing-2);\n    justify-content: flex-end;\n    gap: var(--spacing-1);\n    flex-shrink: 0;\n    border-top: 1px solid var(--border-neutral-medium);\n  }\n\n  .stepperActionsWithFooterContent {\n    justify-content: space-between;\n    padding: var(--spacing-3);\n  }\n\n  .totalLabel {\n    font-size: var(--type-label-sm-font-size);\n  }\n\n  .actionsButtons {\n    gap: var(--spacing-1);\n  }\n\n  .stepperButton {\n    width: auto !important;\n    min-width: 100px !important;\n    max-width: none !important;\n  }\n}\n\n@media (max-width: 600px) {\n  .stepperActionsWithFooterContent {\n    align-items: stretch;\n    flex-direction: column;\n    gap: var(--spacing-1-5);\n    padding: var(--spacing-2);\n  }\n\n  .footerContent {\n    width: 100%;\n  }\n\n  .stepperActionsWithFooterContent .actionsButtons {\n    align-self: flex-end;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepperCard": `Hr9qfP`,
	"stepperHeader": `DKz19_`,
	"stepIndicator": `PCIJWS`,
	"headerActions": `_G6Mtf`,
	"stepCircle": `OdtmyC`,
	"active": `HG2_NE`,
	"completed": `TSIYUM`,
	"inactive": `rp0Vmz`,
	"stepNumber": `VSFMac`,
	"stepTitle": `HR2WOI`,
	"stepDivider": `m5Dum_`,
	"stepperContent": `NgeAhx`,
	"stepperActions": `pnIweR`,
	"stepperActionsWithFooterContent": `ORcEa8`,
	"footerContent": `Ks72yv`,
	"totalValueDisplay": `SPXghZ`,
	"totalLabel": `CjJ8uM`,
	"actionsButtons": `cKUYmq`,
	"stepperButton": `fTULfn`,
	"stepperButtonDisabledNeutral": `AJ_A70`
};
module.exports = ___CSS_LOADER_EXPORT___;
